module.exports = __webpack_public_path__ + "img/标题icon_13.c01f4aaa.png";